(() => {
  if (window.__navTextInit) return;
  window.__navTextInit = true;

  function cleanAndWrap(link) {
    // Evita reprocesar
    if (link.dataset.prepped === '1') return;

    // Texto original
    const original = (link.textContent || '').trim();
    if (!original) return;

    // Seteamos el data-text para el ::after
    link.setAttribute('data-text', original);

    // Limpia cualquier contenido previo (texto, spans antiguos, iconos sueltos)
    // Si el link tiene íconos como <svg> a la derecha, muévelos luego del span.
    const savedSvgs = Array.from(link.querySelectorAll('svg, i.icon, .icon')).map(n => n.cloneNode(true));

    link.textContent = ''; // borra nodos de texto
    const span = document.createElement('span');
    span.className = 'nav-text';
    span.textContent = original;
    link.appendChild(span);

    // Reinyecta iconos si existían
    if (savedSvgs.length) {
      savedSvgs.forEach(svg => link.appendChild(svg));
    }

    link.dataset.prepped = '1';
  }

  function prepLinks(root) {
    const scope = root || document;
    const links = scope.querySelectorAll('#header-component .menu-list__link:not([slot="overflow"])');
    links.forEach(cleanAndWrap);
  }

  function init() {
    const header = document.getElementById('header-component');
    if (header) prepLinks(header);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);

  const mo = new MutationObserver(() => {
    const header = document.getElementById('header-component');
    if (!header) return;
    const needs = header.querySelector('.menu-list__link:not([slot="overflow"]):not([data-prepped="1"])');
    if (needs) prepLinks(header);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
